import React from "react";
import { Space, Tag, Tooltip } from "antd";

import {
  PROCESSING_STATE_COLORS,
  REPLICA_STATUS_COLORS,
  UPLOAD_STATE_COLORS,
} from "../utils/logConstants";

const titleCase = (value) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : "N/A";

/**
 * Lifecycle-state Tag, shared by the table and the detail modal so the two
 * never drift apart on colour or capitalisation.
 */
const StateTag = ({ state, colors }) => (
  <Tag color={colors[state] || "default"}>{titleCase(state)}</Tag>
);

export const UploadStateTag = ({ state }) => (
  <StateTag state={state} colors={UPLOAD_STATE_COLORS} />
);

export const ProcessingStateTag = ({ state }) => (
  <StateTag state={state} colors={PROCESSING_STATE_COLORS} />
);

/**
 * One Tag per storage replica. Unmanaged replicas are dimmed because their
 * status is self-reported by the organisation's own agent rather than observed
 * by the platform.
 */
export const ReplicaTags = ({ locations }) => {
  if (!locations || locations.length === 0) {
    return <Tag>none</Tag>;
  }
  return (
    <Space size={2} wrap>
      {locations.map((replica) => (
        <Tooltip
          key={replica.replica_id}
          title={`${replica.storage_type}${
            replica.managed ? "" : " (self-reported)"
          }: ${replica.status}`}
        >
          <Tag
            color={REPLICA_STATUS_COLORS[replica.status] || "default"}
            style={replica.managed ? {} : { opacity: 0.6 }}
          >
            {replica.storage_type}
            {replica.is_primary ? "*" : ""}
          </Tag>
        </Tooltip>
      ))}
    </Space>
  );
};
